import {Http} from 'vue-resource'
import config from '../config'

class CheckoutService {
  createOrder (registerData) {
    return Http.post(config.API_URL + 'api/checkout/order/create', {register_data: registerData}, {emulateJSON: true})
  }
}

const instance = new CheckoutService()

export default instance
